
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
@Component
export default class EditGame extends Vue {
  @Prop() visiblePass!: Boolean;
  @Prop() flag?: Number;
  @Prop() model!: any;

  rules = {
    oldPass: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
    pass: [{ required: true, trigger: 'blur', validator: this.validatorPassLength }],
    passAgain: [{ required: true, trigger: 'blur', validator: this.validatorPass }],
  };
  validatorPassLength(rule: any, value: any, callback: any) {
    if (value.trim() && value.trim().length >= 3) {
      return callback();
    } else {
      return callback(new Error('请输入新密码,密码长度最少为3位'));
    }
  }
  validatorPass(rule: any, value: any, callback: any) {
    if (value == this.model.pass) {
      return callback();
    } else {
      if (!value) {
        return callback(new Error('请再次输入密码'));
      }
      return callback(new Error('两次密码不一致'));
    }
  }
  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.postNewGameType();
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }
  close() {
    // this.$emit('close');
    this.$emit('update:visiblePass', false);
  }
  async postNewGameType() {
    this.$msgbox({
      title: '提示',
      message: !this.flag ? '是否确认修改密码' : '确认？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          // await postAddGameType(this.model);
          done();
          instance.confirmButtonLoading = false;
          this.$emit('submit');
        } else if (action === 'cancel') {
          instance.confirmButtonLoading = false;
          done();
        }
      },
    })
      .then(() => {
        // done();
      })
      .catch((err: any) => {
        console.log(err, 'postNewGameType');
      });
  }
}
